if (!customElements.get('product-add-to-cart-sticky')) {
class ProductAddToCartSticky extends HTMLElement {
    constructor() {
        super();
        this.handleScroll = this.handleScroll.bind(this);
        this.handleVariantChange = this.handleVariantChange.bind(this);
        this.handleSubmitClick = this.handleSubmitClick.bind(this);
        this.sectionId = this.dataset.section;
        this.scrollTicking = false;
    }

    connectedCallback() {
        this.targetElement = document.querySelector('[id^="ProductSubmitButton-"]');
        this.footerElement = document.querySelector('footer');
        this.submitButton = this.querySelector('button[name="add"]');

        window.addEventListener("scroll", this.handleScroll, { passive: true });
        document.body.addEventListener('change', this.handleVariantChange);
        if (this.submitButton) this.submitButton.addEventListener('click', this.handleSubmitClick);
    }

    disconnectedCallback() {
        window.removeEventListener("scroll", this.handleScroll);
        document.body.removeEventListener('change', this.handleVariantChange);
        if (this.submitButton) this.submitButton.removeEventListener('click', this.handleSubmitClick);
    }

    // The sticky bar owns no form: it validates and submits the main product form so
    // required variant options and custom fields can never be bypassed from here.
    handleSubmitClick(event) {
        event.preventDefault();
        const mainForm = document.getElementById(this.dataset.productId);
        if (!mainForm) return;

        const mainSubmitButton = mainForm.querySelector('[type="submit"][name="add"]') ||
            document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        if (mainSubmitButton && (mainSubmitButton.hasAttribute('disabled') || mainSubmitButton.getAttribute('aria-disabled') === 'true')) return;

        // reportValidity runs constraint validation even though the form has novalidate,
        // focusing and scrolling to the first missing required field.
        if (!mainForm.reportValidity()) return;

        if (this.submitButton) this.submitButton.classList.add('loading');
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            const done = () => {
                if (this.submitButton) this.submitButton.classList.remove('loading');
                unsubscribeUpdate();
                unsubscribeError();
            };
            const unsubscribeUpdate = subscribe(PUB_SUB_EVENTS.cartUpdate, done);
            const unsubscribeError = subscribe(PUB_SUB_EVENTS.cartError, done);
        } else {
            setTimeout(() => {
                if (this.submitButton) this.submitButton.classList.remove('loading');
            }, 3000);
        }

        mainForm.requestSubmit();
    }

    getAbsoluteTop(element) {
        let top = 0;
        while (element) {
            top += element.offsetTop || 0;
            element = element.offsetParent;
        }
        return top;
    }

    handleScroll() {
        if (this.scrollTicking) return;
        this.scrollTicking = true;
        requestAnimationFrame(() => {
            this.scrollTicking = false;
            const targetTopPosition = this.getAbsoluteTop(this.targetElement);
            const footerTopPosition = this.getAbsoluteTop(this.footerElement);
            const isTargetElementOutOfView = targetTopPosition < window.scrollY;
            const isFooterInView = window.scrollY + window.innerHeight > footerTopPosition;

            if (isTargetElementOutOfView && !isFooterInView) {
                this.classList.add('show');
            } else {
                this.classList.remove('show');
            }
        });
    }

    updateStickyATCOption(optionName, optionValue) {
        const matches = optionName.match(/options\[(.+)\]/);
        if (matches && matches[1]) {
            optionName = matches[1];
        }

        const optionDisplay = this.querySelector('.selected-variant-option[data-option-name="' + optionName + '"]');
        if (optionDisplay) {
            optionDisplay.textContent = optionName + ': ' + optionValue;
        }
    }

    handleVariantChange(event) {
        const target = event.target;
        const productSection = target.closest(`#MainProduct-${this.sectionId}`);
        if (!productSection) return;
        if (target.tagName === 'INPUT' || target.tagName === 'SELECT') {
            const optionName = target.name;
            const optionValue = target.tagName === 'INPUT' ? target.value : target.options[target.selectedIndex].textContent;
            this.updateStickyATCOption(optionName, optionValue);
        }
    }
}

customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}
